class AvisoAssunto {
  constructor() {
    this.id = '';
    this.assunto = ''
    this.dataVigenciaInicial = '';
    this.dataVigenciaFinal = '';
    this.version = '';
  }
}

export default AvisoAssunto